<template>
  <div class="content">
    <!--    <common-breadcrumb />-->
    <div v-if="this.$hasConstruction('IEBDC:SY:XXCX:DZZZ:SFZJ')">
      <div>
        <div class="tip">
          <span>电子证照</span>
        </div>
        <div class="form-contnet">
          <el-form label-width="150px" :model="zzcxQuery" :rules="zzcxRules" ref="zzcxForm">
            <!-- <div :class="{ isRedFont: bdcqzhNull }"> -->
            <div class="requireIcon">*</div>
            <certificate-template
              ref="certificatTemplate"
              :tempalteList="tempalteList"
              v-model="zzcxQuery.zh"
              :requiredTag="'zh'"
              :flexWidth="11"
            />
            <!-- </div> -->
            <el-row :gutter="20">
              <el-col :span="11">
                <el-form-item label="权利人证件号" prop="qlrzjh">
                  <el-input v-model="zzcxQuery.qlrzjh" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="权利人名称" prop="qlrmc">
                  <el-input v-model="zzcxQuery.qlrmc" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="22">
                <el-form-item label="查询范围" prop="zlData.zlArea">
                  <zl-directives v-model="zzcxQuery.zlData" :zlConfig="zlConfig"></zl-directives>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="text-right">
              <el-button type="info" @click="resetForm()">重置</el-button>
              <el-button type="primary" @click="zszmSubmit" :loading="loading">查询</el-button>
            </div>
          </el-form>
        </div>
        <e-table
          v-if="tableList.length > 0"
          ref="electronicLincenseRef"
          :tableList="tableList"
          :columns="columns"
          :operates="operates"
          :options="options"
        ></e-table>
        <!--        <div class="bottom" v-if="true">-->
        <!--          <div class="bottom-tip">-->
        <!--            <span>查询结果</span>-->
        <!--          </div>-->
        <!--          <div class="bottom-center">-->
        <!--            <div-->
        <!--              @click="checkImg(0)"-->
        <!--              :class="{activeClass: activeIndex === 0}"-->
        <!--              class="inline-block"-->
        <!--            >电子证照-->
        <!--            </div>-->
        <!--            <div-->
        <!--              @click="checkImg(1)"-->
        <!--              :class="{activeClass: activeIndex === 1}"-->
        <!--              class="inline-block"-->
        <!--            >登记证明-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="bottom-container">-->
        <!--            <div class="bottom-container-title" @click="download">{{title}}</div>-->
        <!--            <el-carousel-->
        <!--              :autoplay="false"-->
        <!--              ref="carousel"-->
        <!--              trigger="click"-->
        <!--              height="478px"-->
        <!--              @change="cursorChange()"-->
        <!--            >-->
        <!--              <el-carousel-item v-for="(item,index) in zszmResult.png_list" :key="index">-->
        <!--                <img ref="image" :src="item" width="100%" height="100%"/>-->
        <!--              </el-carousel-item>-->
        <!--            </el-carousel>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
    <!--  后台配置权限该功能是否在建  -->
    <no-data v-else :data="dataNo"></no-data>
  </div>
</template>

<script>
import { zxTemplate } from '@public/zsMould';
import { queryCeritificateList, downloadCeritificate } from '@iebdc/api/electronic-license';
import hasPermission from '@iebdc/mixin/hasPermission';
import { localDataUser } from '@iebdc/utils/local-data';
// import { validateZjh } from '@iebdc/utils/validate';
import { mapGetters } from 'vuex';
// import { IEBDC_USER_DATA } from '@iebdc/config/app-data';
import { format } from 'date-fns';
import hasConstruction from '@iebdc/mixin/hasConstruction';
import { getCookie } from '../../utils/cookies';

// const userInfo = localDataUser.get();

export default {
  name: 'certificateVerification',
  mixins: [hasPermission, hasConstruction],
  data() {
    this.zzcxRules = {
      // zh: [{ required: true, message: '', trigger: 'blur' }],
      qlrzjh: [{ required: true, message: '请输入权利人证件号', trigger: 'change' }],
      qlrmc: [{ required: true, message: '请输入权利人名称', trigger: 'blur' }],
      'zlData.zlArea': [{ required: true, message: '必填', trigger: 'change' }],
    };
    return {
      loading: false,
      bdcqzhNull: false, // 手动添加验证效果
      dataNo: {
        src: require('@/pages/iebdc/assets/images/nodata@2x.png'),
        imgWidth: '242px',
        imgHeight: '194px',
        title: '敬请期待',
        description: '正在建设中...',
      },
      tempalteList: zxTemplate,
      zzcxQuery: {
        zh: '', // 证号：不动产权证号/不动产登记证明号
        qlrzjh: '', // 权利人证件号
        qlrmc: '', // 权利人名称
        yhm: '', // 用户名
        djjg: '', // 登记机构
        ip: '', // IP地址
        zlData: {
          zlProvince: getCookie('selectedShengCode'),
          zlCity: getCookie('selectedShiCode'),
          zlArea: getCookie('selectedAreaCode'),
        },
      },
      // zszmResult: {},
      // showResult: false,
      // title: '证照下载',
      activeIndex: 0,
      tableList: [],
      columns: [
        {
          label: '权利人名称',
          prop: 'qlrmc',
        },
        {
          label: '权利人证件号',
          prop: 'qlrzjh',
        },
        {
          label: '不动产权证号',
          prop: 'bdcqzh',
        },
        {
          label: '证照名称',
          prop: 'zzmc',
        },
        {
          label: '证照颁发时间',
          prop: 'bfsj',
          formatter: (scope) => {
            if (scope.bfsj) {
              return format(scope.bfsj, 'yyyy-MM-dd');
            } else return '无';
          },
        },
        {
          label: '请求颁发登记机构',
          prop: 'qqbfdjjg',
          width: '120px',
          formatter: (scope) => {
            if (scope.qqbfdjjg) {
              const copyScope = scope.qqbfdjjg;
              let find = this.djjgDictionaries.find((value) => value.djjg === copyScope);
              if (find) {
                return find.jgmc;
              } else {
                return copyScope;
              }
            }
            // const copyScope = '469002';
            // let find = this.djjgDictionaries.find((value) =>
            //   value.djjg === copyScope
            // );
            // if (find) {
            //   return find.jgmc;
            // } else {
            //   return copyScope;
            // }
          },
        },
        {
          label: '颁发原因',
          prop: 'bfyy',
        },
      ],
      operates: {
        //表格操作栏
        width: '100px',
        fixed: 'right',
        list: [
          {
            show: true,
            spanType: 'button',
            id: '1',
            label: '下载',
            type: 'success',
            method: (key, row) => {
              this.$set(row, 'btnLoading', true);
              const params = {
                djjg: this.zzcxQuery.zlData.zlArea || '',
                ip: row.ip || '',
                yhm: this.zzcxQuery.yhm || '',
                zh: row.bdcqzh || '',
              };
              downloadCeritificate(JSON.stringify(params))
                .then((res) => {
                  if (res.data && res.success) {
                    if (res.data.data) {
                      this.$set(row, 'btnLoading', false);
                      // this.downloadUrl = 'data:image/png;base64,' + res.data.data[0].zzxx;
                      // res.data.data[0].zzxx   就是后台返回的base64的 文件流
                      // 后台返回数据+丢失变为空格 这里全局替换空格为+
                      let URL = this.dataURLtoBlob(res.data.data[0].zzxx.replace(new RegExp(' ', 'gm'), '+'));
                      let filenamePDF = row.zzmc ? row.zzmc + '.ofd' : '不动产登记证明' + '.ofd';
                      let reader = new FileReader();
                      reader.readAsDataURL(URL);
                      reader.onload = function (e) {
                        // 兼容IE
                        if (window.navigator.msSaveOrOpenBlob) {
                          let bstr = atob(e.target.result.split(',')[1]);
                          let n = bstr.length;
                          let u8arr = new Uint8Array(n);
                          while (n--) {
                            u8arr[n] = bstr.charCodeAt(n);
                          }
                          let blob = new Blob([u8arr]);
                          window.navigator.msSaveOrOpenBlob(blob, filenamePDF);
                        } else {
                          // 转换完成，创建一个a标签用于下载
                          const a = document.createElement('a');
                          a.download = filenamePDF; // 这里写你的文件名
                          a.href = e.target.result;
                          document.body.appendChild(a);
                          a.click();
                          document.body.removeChild(a);
                        }
                      };
                    } else {
                      this.$set(row, 'btnLoading', false);
                      return this.$message.warning('无证照信息');
                    }
                  }
                })
                .finally(() => this.$set(row, 'btnLoading', false));
            },
            showCallback: () => {
              return true;
            },
          },
        ],
      },
      options: {
        // 每页数据数
        pageSize: 10,
        // 当前页码
        currentPage: 1,
        loading: true,
        mutiSelect: false,
        hasIndex: false,
        height: '556px',
        maxHeight: '556px',
        hasPagination: false,
      },
      zlConfig: {
        zlKey: 'code',
        rules: [],
        hideZl: true,
        disabled: false,
      },
      djjgDictionaries: [],
      userInfo: localDataUser.get(),
    };
  },
  computed: {
    ...mapGetters(['selectedOrganizationsCode', 'selectedOrganizationsTitle', 'finalAreaData']),
  },
  methods: {
    //base64 转换 blob
    dataURLtoBlob(dataurl) {
      let bstr = atob(dataurl); // 解码
      let n = bstr.length;
      let u8arr = new Uint8Array(n); // 创建视图
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: 'ofd' }); // 暂为ofd 后面可能转为pdf
    },
    responseDispose(res, callback) {
      if (res && res.success) {
        callback(res.data);
      }
    },
    zszmSubmit() {
      // 模板含*代表没有填 为触发必填校验需把模板的*置空
      if (this.zzcxQuery.zh.includes('*')) this.zzcxQuery.zh = '';
      // if (!this.zzcxQuery.zh) {
      //   this.bdcqzhNull = true;
      //   return;
      // } else {
      //   this.bdcqzhNull = false;
      this.$refs.zzcxForm.validate((valid) => {
        if (valid) {
          //日志事件点击
          _hmt.push(['_trackEvent', '信息查询', '电子证照', '电子证照']);
          this.loading = true;
          const params = {
            qqjgmc: this.selectedOrganizationsTitle,
            zh: this.zzcxQuery.zh,
            qlrzjh: this.zzcxQuery.qlrzjh,
            qlrmc: this.zzcxQuery.qlrmc,
            yhm: this.zzcxQuery.yhm,
            djjg: this.zzcxQuery.zlData.zlArea,
            ip: '', // 用于记录调用者的IP,随便传一个就行
          };
          queryCeritificateList(JSON.stringify(params))
            .then((res) => {
              if (res.data.data) {
                if (res.data.data[0] && res.success) {
                  this.loading = false;
                  // this.$refs.electronicLincenseRef.setTableList(res.data.page);
                  // this.$refs.electronicLincenseRef.setTotal(res.data.recordCount);
                  this.tableList = (res.data.data || []).filter((item) => {
                    return item.zt === '1';
                  });
                } else {
                  this.loading = false;
                  return this.$message.error('未查询到相关信息！');
                }
              } else {
                this.$message.error(res.data.rtnMessage);
              }
            })
            .finally(() => (this.loading = false));
        }
      });
      // }
    },
    //重置表单
    resetForm() {
      // 解决-点击重置按钮，不动产权证号没有被重置问题
      this.$refs.certificatTemplate.change();
      this.zzcxQuery.yhm = this.userInfo.loginName;
      this.zzcxQuery.qlrmc = this.userInfo.name;
      this.zzcxQuery.qlrzjh = this.userInfo.userCategory === 'NORMAL' ? this.userInfo.zjh : this.userInfo.qyzjh;
      this.zzcxQuery.ip = '';
      this.tableList.length = 0;
    },
    //轮播图切换
    // cursorChange() {
    //   this.activeIndex = this.$refs.carousel.activeIndex;
    //   // console.log(this.$refs.carousel.activeIndex);
    //   if (this.$refs.carousel.activeIndex == 0) {
    //     this.title = '证照下载';
    //   } else {
    //     this.title = '证明下载';
    //   }
    // },
    // download() {
    //   window.open(this.zszmResult.pdf_list[this.$refs.carousel.activeIndex]);
    // },
    // checkImg(index) {
    //   this.activeIndex = index;
    //   this.$refs.carousel.setActiveItem(index);
    // },
  },
  created() {
    this.$bus.$on('selectedZlData', (msg) => {
      this.zzcxQuery.zlData = msg;
    });
    this.zzcxQuery.yhm = this.userInfo.loginName;
    this.zzcxQuery.qlrmc = this.userInfo.name;
    this.zzcxQuery.qlrzjh = this.userInfo.userCategory === 'NORMAL' ? this.userInfo.zjh : this.userInfo.qyzjh;
  },
  beforeDestroy() {
    this.$bus.$off('selectedZlData');
  },
  mounted() {
    // 获取区域code与名称字典
    if (this.finalAreaData[0]) {
      this.finalAreaData[0].childrens.forEach((item1) => {
        item1.childrens.forEach((item2) => {
          item2.bsdtData.forEach((item3) => {
            this.djjgDictionaries.push({ djjg: item3.djjg, jgmc: item3.jgmc });
          });
        });
      });
    }

    // console.log('登记机构字典', this.djjgDictionaries);
    // console.log(this.selectedOrganizationsCode);
    // console.log(this.selectedOrganizationsTitle);
    // console.log(IEBDC_USER_DATA, 'IEBDC_USER_DATA----');
    // this.zzcxQuery.qydm = this.selectedOrganizationsCode; // 获取区域码qydm
    // this.showResult = false; //默认赋值不展示结果框
    // console.log('userInfo--->>>', userInfo);
  },
};
</script>

<style lang="scss" scoped>
@mixin pub-tip {
  border-bottom: 1px solid #dedede;
  font-weight: bold;
}

.activeClass {
  background-color: rgba(255, 91, 36, 1) !important;
  color: rgba(255, 255, 255, 1) !important;
}

.tip {
  @include pub-tip;

  span {
    $color: #ff5b24;
    display: block;
    height: 40px;
    width: 64px;
    line-height: 40px;
    text-align: left;
    color: #000;
    border-bottom: 2px solid $color;
  }
}

.bottom {
  margin-top: 40px;

  .bottom-tip {
    @include pub-tip;

    span {
      $color: #ff5b24;
      display: block;
      height: 40px;
      width: 65px;
      line-height: 40px;
      text-align: left;
      color: #000;
      border-bottom: 2px solid $color;
    }
  }

  .bottom-center {
    margin-top: 20px;

    .inline-block {
      display: inline-block;
      width: 86px;
      height: 40px;
      margin-right: 30px;
      line-height: 40px;
      font-size: 14px;
      text-align: center;
      color: rgba(255, 91, 36, 1);
      background-color: rgba(255, 255, 255, 0);
      border: 1px solid rgba(255, 91, 36, 1);
      cursor: pointer;
    }
  }

  .bottom-container {
    .bottom-container-title {
      margin: 30px 0px 20px 0;
      // text-align: center;
      margin: 20px auto;
      font-size: 16px;
      color: rgba(36, 123, 255, 1);
      width: 64px;
      height: 24px;
      line-height: 24px;
      cursor: pointer;
    }
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  .el-carousel--horizontal {
    width: 693px;
    margin: 0 auto;
  }
}

.form-contnet {
  margin-top: 20px;
  padding: 20px 50px;
  border: 1px solid #dedede;
  .requireIcon {
    color: #f56c6c;
    position: absolute;
    top: 171px;
    right: 581px;
  }
  // .isRedFont:after {
  //   position: absolute;
  //   top: 198px;
  //   right: 513px;
  //   content: '请输入不动产权证号';
  //   color: #f56c6c;
  //   font-size: 12px;
  // }
}
</style>
